// Styles
import styles from './FormsIsEmpty.module.scss';

interface FormsIsEmptyProps {
    title: string;
    text: string;
    imageSrc?: string;
    alt?: string;
}

const FormsIsEmpty = ({
    title,
    text,
    imageSrc = '/images/memberships/clients-notfound.svg',
    alt = 'No forms'
}: FormsIsEmptyProps) => {
    return (
        <div
            className={styles.containerEmpty}
            data-testid="forms-empty"
        >
            <img
                className={styles.imageEmpty}
                src={imageSrc}
                alt={alt}
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                <p className={styles.descriptionEmpty}>{text}</p>
            </div>
        </div>
    );
};

export default FormsIsEmpty;
